import { InboxIcon, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  /** `bordered` draws a dashed panel; `plain` is for use inside cards/tables. */
  variant?: "bordered" | "plain";
  className?: string;
}

export function EmptyState({
  icon: Icon = InboxIcon,
  title,
  description,
  action,
  variant = "bordered",
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center px-6 py-14 text-center",
        variant === "bordered" && "rounded-lg border border-dashed bg-card/50",
        className,
      )}
    >
      <div className="mb-4 flex size-11 items-center justify-center rounded-xl border bg-card shadow-xs">
        <Icon className="size-5 text-muted-foreground" aria-hidden="true" />
      </div>
      <h2 className="text-sm font-semibold">{title}</h2>
      {description && <p className="mt-1 max-w-sm text-[13px] text-muted-foreground text-pretty">{description}</p>}
      {action && <div className="mt-5 flex flex-wrap justify-center gap-2">{action}</div>}
    </div>
  );
}
